import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftTransparent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.3535 27.2606H24.1182C24.703 27.2606 25.177 26.7865 25.177 26.2018V16.6724 H5" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.3535 27.2606H7.17704C6.59227 27.2606 6.11822 26.7865 6.11822 26.2018V16.6724" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 12.3784C4 11.8261 4.44772 11.3784 5 11.3784H26.2941C26.8464 11.3784 27.2941 11.8261 27.2941 12.3784V15.6725C27.2941 16.2248 26.8464 16.6725 26.2941 16.6725H5C4.44772 16.6725 4 16.2248 4 15.6725V12.3784Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.6465 27.2608V11.3784" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.6684 8.38408C19.8942 9.77539 17.8572 10.7939 15.6797 11.3784C16.2642 9.20089 17.2827 7.1639 18.674 5.38973C20.5362 3.52902 21.5907 3.8142 22.4237 4.64149C23.2566 5.46879 23.5305 6.52338 21.6684 8.38408Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.62374 8.38408C11.3981 9.77513 13.435 10.7936 15.6124 11.3784C15.0286 9.20064 14.01 7.16352 12.6181 5.38973C10.7574 3.52902 9.7028 3.8142 8.86986 4.64149C8.03691 5.46879 7.76303 6.52338 9.62374 8.38408Z" })
	]
});
export default SvgGiftTransparent;
